  import { Injectable } from '@angular/core';
import {protectedResources} from "../../auth-config";
import { HttpClient } from "@angular/common/http";
  import {Observable} from "rxjs";
  import {BuildKit} from "../models/build-kit.model";
  import {GlobalSearchResultItem} from "../models/global-search.model";

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {

  brennerSoftwareApiEndpoint: string = protectedResources.BrennerSoftwareApi.endpoint;

  constructor(
    private http: HttpClient
  ) {}

  search(searchTerm: string): Observable<any> {
    return this.http.get<GlobalSearchResultItem[]>(this.brennerSoftwareApiEndpoint + `globalSearch/search/${searchTerm}`);
  }
}
